let pathPrefix = process.env.VUE_APP_API_PATH_PREFIX;

export function setPathPrefix(prefix: string) {
  pathPrefix = prefix;
}

export function getPathPrefix() {
  return pathPrefix;
}
